export const TARGET_AUDIENCE_TYPES = {
    ALL: 'all',
    SEGMENT: 'segment',
    MANUAL: 'manual',
    PROGRAM: 'program'
};

export const PROGRAM_TYPES = {
    NUTRITION: 1,
    FITNESS: 2,
    WELLNESS: 3
};

export const TARGET_OPTIONS = [
    { value: 1, label: 'Dashboard' },
    { value: 2, label: 'Content' },
    { value: 3, label: 'Meal plan' },
    { value: 4, label: 'Fitness program' },
    { value: 5, label: 'Nutrition program' },
    { value: 6, label: 'Wellness program' },
    { value: 7, label: 'Blood results' },
    { value: 8, label: 'MirrorMirror' }
];